import Step3 from './Step3'

export default Step3
